import { createStringStorage } from "./browser"

const storage = createStringStorage("mux:client-actor:v1")
let cached: string | undefined

function generateActorID() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID()
  const bytes = new Uint8Array(16)
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") crypto.getRandomValues(bytes)
  else for (let index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256)
  return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("")
}

/** Stable browser-profile identity for event attribution. It is not an authentication credential. */
export function browserActorID() {
  if (cached) return cached
  cached = storage.read().trim()
  if (cached) return cached
  cached = generateActorID()
  storage.write(cached)
  return cached
}
